<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button mat-mini-fab color="primary" (click)="scrollToTop()">
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
</div>
